import {
   FETCH_EXCEPTION_NOTONERA_INVOICELIST_FAILURE,
   FETCH_EXCEPTION_NOTONERA_INVOICELIST_SUCCESS,
   FETCH_EXCEPTION_NOTONERA_INVOICELIST_REQUEST
  } from "./FetchPaymentExceptionEraTypes";
  
  const initialState = {
    loading: false,
    allocatedInvoiceInvoiceList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_EXCEPTION_NOTONERA_INVOICELIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_EXCEPTION_NOTONERA_INVOICELIST_SUCCESS:
        return {
          loading: false,
          exceptionNoEraInvoiceList: action.payload,
          error: "",
        };
      case FETCH_EXCEPTION_NOTONERA_INVOICELIST_FAILURE:
        return {
          loading: false,
          exceptionNoEraInvoiceList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  